import { mapGetters } from "vuex";
import * as STEPPER_GETTER from "../../../../store/stepper/getter-types";

export default {
  props: {
    activeStep: {
      type: Number,
      required: true,
      default: () => 0
    }
  },
  data: () => {
    return {
      overlay: false
    }
  },
  computed: {
    ...mapGetters({
      stepper: STEPPER_GETTER.GET_STEPPER
    })
  },
  created() {
    this.$eventHub.$on('update-overlay', this.handleOverlayUpdate);
  },
  mounted() {
    this.toggleMargin();
    window.onresize = window._.debounce(this.toggleMargin, 500);
  },
  beforeDestroy() {
    this.$eventHub.$off('update-overlay');
  },
  methods: {
    toggleMargin() {
      document.querySelector('.v-main__wrap').classList[window.innerWidth < 1280 ? 'add' : 'remove']('margin-bottom');
    },
    goToStep(stepNumber) {
      if (
        stepNumber < this.activeStep ||
        this.stepper.steps[stepNumber].comlpeted
      ) {
        this.$emit("goToStep", stepNumber);
      }
    },
    handleStepComplete: function(items) {
      this.$emit("stepComplete");
    },
    handleOverlayUpdate(value) {
      this.overlay = value;
    }
  }
};
